<script>
  import { criaCategoria } from '../../actions/database.js';

  import Page from "../../containers/Page/Page.svelte";
  import Modal from "../../components/Modal/Modal.svelte";

  let categoria = {
    ativo: 'sim'
  };
  let alert;
  let files;
  let uploading;
  let error;

  const handleCreate = async () => {
    alert = "Adicionando...";
    try {
      await criaCategoria(categoria);
      alert = "Categoria adicionada!";
    } catch (error) {
      alert = `Erro ao adicionar categoria: ${error}`;
    }
  }

  const close = () => alert = null;
</script>

{#if alert}
  <Modal
    { alert }
    { close }
  />
{/if}

<Page title="Criar Categoria">
  <div class="box">
    <div class="field is-horizontal">
      <div class="content">
        <h3>Dados da categoria:</h3>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Nome</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control is-expanded">
            <input bind:value={categoria.nome} class="input" type="text">
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Ativo</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control is-expanded">
            <div class="select">
              <select bind:value={categoria.ativo}>
                <option value="nao">Não</option>
                <option value="sim">Sim</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Descrição</label>
      </div>
      <div class="field-body">
        <div class="field">
          <div class="control">
            <textarea bind:value={categoria.descricao} class="textarea"></textarea>
          </div>
        </div>
      </div>
    </div>
    <div class="control has-text-right">
      <button
        on:click={handleCreate}
        class="button is-primary"
      >
        Adicionar categoria
      </button>
    </div>
  </div>

</Page>